<script>
import { mapActions } from 'vuex';

export default {
    props: {
        code: {
            required: true,
            type: String,
        },
    },

    mounted() {
        this.applyCouponCode(this.code);
    },

    methods: {
        ...mapActions('cart', ['applyCouponCode']),
    },

    render() {},
};
</script>
